import React, { Fragment, useContext, useEffect, useState } from "react";
import user from "../models/User";
import {Box,Toolbar} from "@mui/material";
import Header from "../ComponentParts/Header";
import Sidebar from "../ComponentParts/Sidebar";
import MapView from "../ComponentParts/MapView";

import {DashboardContextProvider,DashboardContext} from "../Context/DashboardContext";
import { Route, Routes, useLocation } from "react-router-dom";
import EditVehiclePage from "./EditVehiclePage";
import HistoryPage from "./HistoryPage";
import SidebarUserList from "../ComponentParts/SidebarUserList";
import MobileNavigation from "../ComponentParts/MobileNavigation";
import { useMediaQuery } from "@mui/material";
import SidebarMobile from "../ComponentParts/SidebarMobile";
import { el } from "date-fns/locale";

function Dashboard() {

    const location = useLocation();

    const isLargeScreen = useMediaQuery('(min-width:600px)');
    
    const [mobileSidebarOpen,setMobileSidebarOpen] = useState(false); 

    const [renderMobileNav,setRenderMobileNav] = useState(true);

    useEffect(() => {
        if( location.pathname.includes("/history_vehicle/")){
            setRenderMobileNav(false);
        }else{
            setRenderMobileNav(true);
        }
    }, [location]); 

    return (

        <DashboardContextProvider>
            <Box style={{display : "flex", flexDirection : "column"}}>
                <Header/>
                <Box style={{display : "flex"}}> 
                    {isLargeScreen ?
                        <Sidebar/>
                        : null
                    }

                    <Box>
                        <Toolbar />
                        <Routes>
                            <Route path="/" element={<MapView/>}/>
                            <Route path="/edit_vehicle/:id" element={<EditVehiclePage/>}/>
                            <Route path="/history_vehicle/:id" element={<HistoryPage/>}/>

                        </Routes>
                    </Box>
                    {/*<SidebarUserList/>*/}

                </Box>

                {!isLargeScreen ?
                    <Fragment>
                        <SidebarMobile open={mobileSidebarOpen} onClose={() => {setMobileSidebarOpen(false)}}/>
                        {renderMobileNav ?
                        <MobileNavigation mobileSidebarOpen={mobileSidebarOpen} setMobileSidebarOpen={setMobileSidebarOpen} />
                        : null
                        }
                    </Fragment>
                    
                    :
                    null
                }
                
            </Box>
        </DashboardContextProvider>
    )
}

export default Dashboard